import auth from './auth.json'
import common from './common.json'
import mentions from './mentions.json'
import privacy from './privacy.json'
import series from './series.json'
import timeline from './timeline.json'
import post from './post.json'

export default { ...auth, ...common, ...mentions, ...privacy, ...series, ...timeline, ...post }
